import {
    Experience,
    ExperiencePurchaseItem,
    Merchandise,
    MerchandisePurchaseItem,
    Package,
    PartnerPackage,
    Purchase,
    PurchaseItemObject,
} from "types";
import { CreatePurchaseItemState, CreatePurchaseState } from "@/stores/createPurchaseStore";

export const calculateDeposit = (
    productItem: Experience | Package | PartnerPackage | Merchandise,
    purchase: Purchase | CreatePurchaseState,
    item: ExperiencePurchaseItem | MerchandisePurchaseItem | CreatePurchaseItemState,
) => {
    // Deposit is not allowed for gift purchases
    if (item?.object === PurchaseItemObject.GIFT || !productItem?.downDeposit?.amount) {
        return 0;
    }

    const deposit = productItem.downDeposit;
    if (deposit.amountType === "percent") {
        return (purchase.amount * deposit.amount) / 100;
    }

    if (deposit.amountType === "absolute") {
        if (deposit.scope === "outing") {
            return deposit.amount;
        }

        if (deposit.scope === "person") {
            return deposit.amount * item.quantity;
        }
    }

    return 0;
};
